import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Globe, Lock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_travel-booking-hub-90/artifacts/txbpb6pw_20260506_060747_0000.png';

const Header = () => {
  const { t, lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { href: '#services', label: t.nav.services },
    { href: '#fleet', label: t.nav.fleet },
    { href: '#reservation', label: t.nav.reserve },
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/' + href);
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    setOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="TTS" className="h-20 w-auto object-contain drop-shadow-[0_4px_12px_rgba(255,107,26,0.4)]" />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="text-white/85 hover:text-[#ff6b1a] transition-colors text-sm font-medium tracking-wide"
              >
                {item.label}
              </a>
            ))}
            <Link to="/excursiones" className="text-white/85 hover:text-[#ff6b1a] transition-colors text-sm font-medium tracking-wide">
              {t.nav.excursions}
            </Link>
            <Link to="/admin/login" className="flex items-center gap-1.5 text-white/85 hover:text-[#ff6b1a] transition-colors text-sm font-medium tracking-wide">
              <Lock className="w-3.5 h-3.5" /> {t.nav.admin}
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 border border-white/15 rounded-md p-0.5 bg-black/40">
              <button
                onClick={() => setLang('es')}
                className={`px-2.5 py-1 rounded text-xs font-bold transition-colors ${lang === 'es' ? 'bg-[#ff6b1a] text-white' : 'text-white/70 hover:text-white'}`}
                aria-label="Español"
              >
                ES
              </button>
              <button
                onClick={() => setLang('en')}
                className={`px-2.5 py-1 rounded text-xs font-bold transition-colors ${lang === 'en' ? 'bg-[#ff6b1a] text-white' : 'text-white/70 hover:text-white'}`}
                aria-label="English"
              >
                EN
              </button>
            </div>
            <Button
              onClick={(e) => handleNavClick(e, '#reservation')}
              className="hidden md:inline-flex btn-orange border-0 rounded-md px-5"
            >
              {t.nav.reserve}
            </Button>
            <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-2">
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-4 animate-fadeUp">
            <nav className="flex flex-col gap-2 pt-4 border-t border-white/5">
              {navItems.map((item) => (
                <a key={item.href} href={item.href} onClick={(e) => handleNavClick(e, item.href)} className="text-white/85 hover:text-[#ff6b1a] py-2 px-2 transition-colors">
                  {item.label}
                </a>
              ))}
              <Link to="/excursiones" onClick={() => setOpen(false)} className="text-white/85 hover:text-[#ff6b1a] py-2 px-2">
                {t.nav.excursions}
              </Link>
              <Link to="/admin/login" onClick={() => setOpen(false)} className="text-white/85 hover:text-[#ff6b1a] py-2 px-2 flex items-center gap-2">
                <Lock className="w-4 h-4" /> {t.nav.admin}
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
